/**
 * Placeholder de carga.
 * - **shimmer** (por defecto): gradiente ann (#F2F2F2 / #D9D9D9) + animación horizontal.
 * - **pulse**: alterna #F2F2F2 y #D9D9D9 (misma pareja que el shimmer), sin animar opacidad.
 */

function toCss(value) {
  if (value == null) return undefined;
  if (typeof value === 'number' && Number.isFinite(value)) return `${value}px`;
  return String(value);
}

/**
 * @param {object} props
 * @param {number|string} [props.width='100%']
 * @param {number|string} [props.height='20px']
 * @param {number|string} [props.borderRadius='4px']
 * @param {boolean} [props.animation=true]
 * @param {'shimmer'|'pulse'} [props.animationStyle='shimmer'] — Solo aplica si `animation` es true.
 * @param {string} [props.className]
 */
const Skeleton = ({
  width = '100%',
  height = '20px',
  borderRadius = '4px',
  animation = true,
  animationStyle = 'shimmer',
  className = '',
}) => {
  const style = {
    width: toCss(width),
    height: toCss(height),
    borderRadius: toCss(borderRadius),
  };

  const useShimmer = animation && animationStyle === 'shimmer';
  const usePulse = animation && animationStyle === 'pulse';

  if (useShimmer) {
    style.backgroundSize = '200px 100%';
  }

  return (
    <div
      className={[
        'box-border block min-h-0 min-w-0 overflow-hidden',
        useShimmer &&
          [
            'animate-skeleton-shimmer',
            'bg-[linear-gradient(90deg,#F2F2F2_0px,#D9D9D9_40px,#F2F2F2_80px)]',
            'dark:bg-[linear-gradient(90deg,#374151_0px,#6b7280_40px,#374151_80px)]',
          ].join(' '),
        usePulse &&
          'bg-[#F2F2F2] animate-skeleton-pulse dark:bg-[#5f5f5f] dark:animate-skeleton-pulse-dark',
        !animation && 'bg-[#F2F2F2] dark:bg-gray-700',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={style}
      role="status"
      aria-hidden="true"
    />
  );
};

export default Skeleton;
